// extracted by mini-css-extract-plugin
export default {"codeEditor":"codeEditor--yZP2v","border":"border--tvfDa"};